import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import CloseIcon from "@mui/icons-material/Close";
import AppContext from "../context/context";
import { toast } from "react-toastify";
import { freightBrokerService } from "../../utils/services/freightBrokerService";

const FreightBrokerModal = ({
  open,
  handleClose,
  onAddData,
  selectedFreightBroker,
}) => {
  const [freightBrokerDetails, setFreightBrokerDetails] = useState({
    address: "",
    name: "",
    accountNo: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const { user } = useContext(AppContext);
  const clientId = localStorage.getItem("client_id");

  useEffect(() => {
    if (selectedFreightBroker) {
      setFreightBrokerDetails({
        address: selectedFreightBroker?.address || "",
        name: selectedFreightBroker?.name || "",
        accountNo: selectedFreightBroker?.accountNo || "",
      });
    } else {
      initialData();
    }
  }, [selectedFreightBroker]);
  const initialData = () => {
    setFreightBrokerDetails({
      address: "",
      name: "",
      accountNo: "",
    });

    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFreightBrokerDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditData = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await freightBrokerService.edit(selectedFreightBroker._id, {
        ...freightBrokerDetails,
      });
      onAddData && onAddData();
      toast.success("Freight broker updated successfully!");
      initialData();
    } catch (e) {
      toast.error("Failed to update Freight broker.");
      console.error(e);
    }
    handleClose();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await freightBrokerService.create({
        ...freightBrokerDetails,
      });

      onAddData && onAddData();
      toast.success("Freight broker created successfully!");
      handleClose();
      initialData();
    } catch (e) {
      toast.error("Failed to create Freight broker.");
      console.error(e);
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!freightBrokerDetails.address) {
      errors.address = "address is required.";
    }
    if (!freightBrokerDetails.name) {
      errors.name = " Name is required.";
    }
    if (!freightBrokerDetails.accountNo) {
      errors.accountNo = "Account No is required.";
    } else if (freightBrokerDetails.accountNo < 1) {
      errors.accountNo = "Account No Should not be negative";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        initialData();
      }}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontFamily: "Poppins",
            fontSize: 24,
            fontWeight: 500,
            color: "var(--text-primary)",
          }}
        >
          {selectedFreightBroker ? "Edit" : "Create"} Freight Broker
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#11193F",
              }}
            >
              Name <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="name"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={freightBrokerDetails.name}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.name}
              helperText={formErrors.name}
              placeholder="Enter Name"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#11193F",
              }}
            >
              Account No <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="accountNo"
              type="number"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={freightBrokerDetails.accountNo}
              onChange={handleInputChange}
              inputProps={{ min: 0 }}
              fullWidth
              margin="dense"
              error={!!formErrors.accountNo}
              helperText={formErrors.accountNo}
              placeholder="Enter Account No"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#11193F",
              }}
            >
              Address <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              placeholder="Enter Address"
              name="address"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={freightBrokerDetails.address}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.address}
              helperText={formErrors.address}
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ paddingBottom: 15, paddingRight: 15 }}>
        <Button
          style={{
            fontFamily: "Poppins",
            fontSize: 14,
            fontWeight: 600,
            color: "#007DFF",
            textTransform: "none",
          }}
          variant="outlined"
          onClick={() => {
            handleClose();
            initialData();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={(e) =>
            selectedFreightBroker ? handleEditData(e) : handleSave(e)
          }
          color="primary"
          variant="contained"
          style={{
            color: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: 14,
            fontWeight: 600,
            width: 100,
            textTransform: "none",
          }}
        >
          {selectedFreightBroker ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FreightBrokerModal;
